import styles from './styles.module.css';
import { DiagramDataTableShortItem } from '../../../../types/deal-taxes';
import { SelectedItemAsset } from '../../../../components/SelectionPopup/SelectionPopup';
import { Asset } from '../../../../types/general';

interface DealTaxesDetailRowProps {
    rowTitle: string;
    data: DiagramDataTableShortItem[];
    isActive: boolean;
    legendChange: any;
    isMultiAsset: boolean;
    asset?: Asset;
}

const DealTaxesDetailRow = ({
    rowTitle,
    data,
    isActive,
    legendChange,
    isMultiAsset,
    asset,
}: DealTaxesDetailRowProps) => {
    const handleTipEnter = (tip: any) => {
        legendChange(tip.legendId);
    };

    const handleMouseLeave = () => {
        legendChange(null);
    };

    return (
        <div className={`${styles.row} ${isActive ? styles.active : ''}`}>
            <h5 className={styles.rowTitle}>{rowTitle}</h5>
            <div className={styles.rowData}>
                {data.map((d: DiagramDataTableShortItem, index: number) => {
                    return (
                        <div
                            key={index}
                            className={styles.group}
                            onMouseEnter={() => handleTipEnter(d)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className={styles.groupRow}>
                                <h6 className={styles.groupTitle}>{d.tax}</h6>
                                <span className={`${styles.groupValue} ${styles.valueBold}`}>{d.taxRate}</span>
                            </div>
                            <div className={styles.groupRow}>
                                <h6
                                    className={`${styles.groupValue} ${styles.groupValueText} ${styles.groupValueTextLight}`}
                                >
                                    {isMultiAsset && Array.isArray(d?.assetClasses)
                                        ? d?.assetClasses?.join('; ')
                                        : d?.assetClasses || ''
                                          ? d?.assetClasses || ''
                                          : asset?.assetClass || ''}
                                </h6>

                                <span className={`${styles.groupValue} ${styles.groupValueText}`}>
                                    {d.taxBase}
                                    {d.legendId && <span className={styles.legend}>{d.legendId}</span>}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DealTaxesDetailRow;
